import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useMusic } from '../context/MusicContext';

const HeaderContainer = styled.header`
  background: linear-gradient(to bottom, rgba(33 67 154 / 0.9), rgba(42 127 183 / 0.85), rgba(106, 176, 222, 0.8));
  padding: 5px 0;
  box-shadow: 0 4px 15px rgba(74, 144, 226, 0.2);
  border-bottom: 3px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Logo = styled.div`
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  font-weight: 700;
  color: var(--light-text);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 4.5rem;
`;

const LogoImage = styled.img`
  height: 6rem;
  width: auto;
  vertical-align: middle;
  object-fit: contain;
  
  @media (max-width: 768px) {
    height: 5rem;
  }
  
  @media (max-width: 480px) {
    height: 4rem;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;

  @media (max-width: 768px) {
    margin-top: 15px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }
`;

const NavLink = styled(Link)`
  color: var(--light-text);
  font-weight: 600;
  padding: 8px 16px;
  position: relative;
  transition: all 0.3s ease;
  border-radius: 20px;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  
  &:after {
    content: '';
    position: absolute;
    width: ${props => props.active ? '100%' : '0'};
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: var(--light-text);
    transition: width 0.3s ease;
    opacity: 0.8;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
    color: var(--light-text);
  }
  
  ${props => props.active && `
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  `}
`;

const Header = () => {
  const location = useLocation();
  
  return (
    <HeaderContainer>
      <Nav>
        <Logo>
          <LogoImage src="/img/logo/compressed/logo1.png" alt="Logo Fête des Pères" />
          FDP
        </Logo>
        <NavLinks>
          <NavLink to="/" active={location.pathname === '/' ? 1 : 0}>
            Accueil
          </NavLink>
          <NavLink to="/gallery" active={location.pathname === '/gallery' ? 1 : 0}>
            Galerie
          </NavLink>
          <NavLink to="/poems" active={location.pathname === '/poems' ? 1 : 0}>
            Poèmes
          </NavLink>
          <NavLink to="/compliments" active={location.pathname === '/compliments' ? 1 : 0}>
            Compliments
          </NavLink>
          <NavLink to="/surprise" active={location.pathname === '/surprise' ? 1 : 0}>
            Surprise
          </NavLink>
        </NavLinks>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
